import { render, staticRenderFns } from "./GoodsReturnList.vue?vue&type=template&id=3eef0eb6"
import script from "./GoodsReturnList.vue?vue&type=script&lang=js"
export * from "./GoodsReturnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports